import { render, staticRenderFns } from "./Sim.vue?vue&type=template&id=0d5db6d5"
import script from "./Sim.vue?vue&type=script&lang=ts"
export * from "./Sim.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports